import { ReactNode } from 'react'

import { CompanyPageCachingProvider } from '@/components/CompanyPage/CompanyPageContext'
import { TrendV2CachingProvider } from '@/components/TrendV2/TrendV2Context'
import { AnalyticsCachingProvider } from '@/components/Analytics/AnalyticsMonitorContext'

export const BackgroundMonitorProvider = ({ children }: { children: ReactNode }) => {
  return (
    <CompanyPageCachingProvider>
      <TrendV2CachingProvider>
        <AnalyticsCachingProvider>{children}</AnalyticsCachingProvider>
      </TrendV2CachingProvider>
    </CompanyPageCachingProvider>
  )
}
